import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Asset_retranscode,
  AssetLogoAction,
  AssetPublish,
  AssetTranscode,
  AssetValidate,
  CopyAsset,
  DecodeAssetStatus,
  FillerList,
  ProgramsList_By_Partner,
  PromosList_By_Partner,
} from "../../api/api";
import desc from "../../assets/images/desc.png";
import filterimg from "../../assets/images/sort.png";
import filter_alt from "../../assets/images/sortarrow.png";
import PrevButton from "../../component/Common/PrevButton";
import NextButton from "../../component/Common/NextButton";
import donecheck from "../../assets/svg/Action/compltedIcon.svg";
import downarrow from "../../assets/svg/Action/downarrow.svg";
import error from "../../assets/svg/Action/Error.svg";
import FinalisingIcon from "../../assets/svg/Action/finalizingIcon.svg";
import CrossIcon from "../../assets/svg/Action/iconamoon_close-fill.svg";
import override from "../../assets/svg/Action/override.svg";
import pending from "../../assets/svg/Action/pending.svg";
import refresh from "../../assets/svg/Action/refresh.svg";
// import icroundsearch from "../../assets/svg/Assetmanagemant/search.svg";
import Searchicon from "../../assets/svg/Action/searchicon.svg";
import processing from "../../assets/svg/Assetmanagemant/spin.svg";
import Validatepopup from "../../component/popup/asset-action-popup/Validatepopup";
import SearchBar from "../../component/search-bar/searchBar";
import CustomTooltip from "../../component/Tooltip";
import {
  convertTimestampToTime,
  DateStamp,
  isLogin
} from "../../service/commonFunc";
import { permissionDetails } from "../../utility/localStoageData";
import "./ChannelActions.scss";
import Loader from "../../component/Loader/Loader";



const ErrorPopup = ({ isOpen, onClose, errorMessage, onReTranscode, onReDecode, onReCopy, assetData, errorType, errorCache, selectedType }) => {
  if (!isOpen) return null;

  const isTranscodeError =
    errorCache[`${assetData?.id}`]?.transcoding === "ERROR" ||
    assetData?.transcodingStatus === "ERROR" || assetData.logoTranscodingStatus  === "ERROR" ||
    (selectedType === "PROGRAM" && 
      (errorCache[`${assetData?.id}`]?.logoTranscoding === "ERROR" ||
        assetData?.logoTranscodingStatus === "ERROR" ||
        assetData?.completeTranscodingStatus === "ERROR"));
  const isDecodeError =
    errorCache[`${assetData?.id}`]?.decoding === "ERROR" ||
    assetData?.decodingStatus === "ERROR";
  const isCopyError =
    errorCache[`${assetData?.id}`]?.copy === "ERROR" ||
    assetData?.copyStreamStatus === "ERROR";

  let popupWidth = "365px";
  const getErrorMessage = () => {
    if (errorMessage && errorMessage !== "An error occurred during processing") {
      return errorMessage;
    }
    switch (errorType) {
      case "transcode":
        return `Transcoding failed for "${assetData?.metadata?.title || assetData?.filename || "unknown asset"}". Possible issues: unsupported file format${selectedType === "PROGRAM" ? ", logo processing error," : "" // Now selectedType is defined as a prop
          } or server error.`;
      case "decode":
        return `Decoding failed for "${assetData?.metadata?.title || assetData?.filename || "unknown asset"}". The media stream could not be processed.`;
      case "copy":
        return `Copying failed for "${assetData?.metadata?.title || assetData?.filename || "unknown asset"}". There was an issue with file transfer or storage.`;
      default:
        return `An unexpected error occurred while processing "${assetData?.metadata?.title || assetData?.filename || "unknown asset"}".`;
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(11, 11, 11, 0.7)",
        display: "flex", justifyContent: "center", alignItems: "center",
        zIndex: 1000, overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#1e1e1e",
          color: "#e0e0e0",
          padding: "20px",
          borderRadius: "12px",
          width: popupWidth,
          minHeight: "234px",
          maxWidth: "90vw",
          maxHeight: "90vh",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.6)",
          border: "1px solid #333",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          animation: "fadeInScale 0.3s ease-out",
        }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="error-popup-title"
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: "15px", right: "15px",
            backgroundColor: "#444649", border: "none", fontSize: "14px",
            cursor: "pointer", padding: "4px", lineHeight: 1,
            borderRadius: "10%", width: "24px", height: "24px",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
          aria-label="Close"
        >
          <img src={CrossIcon} alt="Close" />
        </button>

        <div>
          <h3
            id="error-popup-title"
            style={{
              margin: "30px 0 12px 0",
              color: "#ffffff",
              fontSize: "20px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            {errorType === "transcode" ? "Transcoding Error" :
              errorType === "decode" ? "Decoding Error" :
                errorType === "copy" ? "Copy Error" : "Error Details"}
          </h3>
          <p
            style={{
              margin: "20px 0 12px 0",
              color: "#cccccc",
              fontSize: "14px",
              lineHeight: "1.6",
              textAlign: "center",
              maxHeight: "120px", 
              overflowY: "auto", 
              paddingRight: "8px",
              overflowWrap: "break-word", 
              wordBreak: "break-word",
            }}
          >
            {getErrorMessage()}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "12px",
          }}
        >
          {isTranscodeError ? (
            <button
              onClick={() => onReTranscode(assetData)}
              style={{
                padding: "10px 24px",
                backgroundColor: "#D22F26",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: 400,
                minWidth: "120px",
              }}
            >
              Re-Transcode
            </button>
          ) : isDecodeError ? (
            <button
              onClick={() => onReDecode(assetData)}
              style={{
                padding: "10px 24px",
                backgroundColor: "#D22F26",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: 400,
                minWidth: "120px",
              }}
            >
              Re-Decode
            </button>
          ) : isCopyError ? (
            <button
              onClick={() => onReCopy(assetData)}
              style={{
                padding: "10px 24px",
                backgroundColor: "#D22F26",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: 400,
                minWidth: "120px",
              }}
            >
              Re-Copy
            </button>
          ) : null}

          <button
            onClick={onClose}
            style={{
              padding: "10px 24px",
              backgroundColor: "#333333",
              color: "#ffffff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 400,
              minWidth: "120px",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default function ChannelActionsComponent() {
  const AssetActionDetail = JSON.parse(localStorage.getItem("AssetDetail"));
  const AssetPartnerDetail = JSON.parse(localStorage.getItem("AssetPartnerDetail"));
  const [actionDetail, setActionDetail] = useState([]);
  const [isContentLoading, setIsContentLoading] = useState(false);
  const [actionData, setActionData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState({});
  const [tooltipText, setTooltipText] = useState('');
  const [errorPopup, setErrorPopup] = useState({ isOpen: false, message: '', assetData: null, errorType: null });
  const [errorCache, setErrorCache] = useState({});
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [inputPage, setInputPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuerys, setSearchQuery] = useState("");
  const [searchButtonClicked, setSearchButtonClicked] = useState(false);
  const [rotation, setRotation] = useState(0);
  const typeOptions = ["PROGRAM", "PROMO", "FILLER"];
  const [selectedType, setSelectedType] = useState("PROGRAM");
  const [permission, setPermission] = useState(false);
  const [currentSortOrder, setCurrentSortOrder] = useState({
    sortBy: "filename",
    sortOrder: "asc",
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [validatepopup, setValidatePopup] = useState(false);
  const [transcodeActive, setTranscodeActive] = useState(false);
  const [validateActive, setValidateActive] = useState(false);
  const [publishActive, setPublishActive] = useState(false);
  const [validatedata, setValidate] = useState(null);
  const [assetSignledata, setAssetSignledata] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [currentAction, setCurrentAction] = useState("");
  const [checkedIds, setCheckedIds] = useState([]);
  const [isChecked, setChecked] = useState(false);
  const [allcheck, setAllcheck] = useState(false);
  const [disabledFiled, setDisabledFiled] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const intervalRef = useRef(null);
  let disabledIds = []

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    document.addEventListener('click', closeDropdown);
    return () => document.removeEventListener('click', closeDropdown);
  }, []);

 const fetchData = useCallback(async (currentPage) =>  {
     setIsContentLoading(true); // Start loader
    const params = {
      partnerId: AssetPartnerDetail?.id,
      pageSize: itemsPerPage,
      sortBy: currentSortOrder.sortBy,
      sortOrder: currentSortOrder.sortOrder,
      pageNumber: searchQuerys ? 0 : currentPage-1,
      ...(searchQuerys ? { searchQuery: searchQuerys } : null),
    };

    try {
      let response;
      if (selectedType === "PROGRAM") {
        response = await ProgramsList_By_Partner(params);
      } else if (selectedType === "FILLER") {
        response = await FillerList(params);
      } else if (selectedType === "PROMO") {
        response = await PromosList_By_Partner(params);
      }

      if (response.status === true) {
        localStorage.setItem(
          selectedType === "PROGRAM" ? "AssetDetail" : "fillerDetail",
          JSON.stringify(response.data)
        );
        setActionDetail(response.data?.content || []);
        setActionData(response.data);
        setTotalPages(response?.data?.totalPages || 0);
        setCurrentPage(response?.data?.number + 1 || 1);
        setInputPage(response?.data?.number + 1 || 1)
        
        const newErrorCache = { ...errorCache };
        response.data.content.forEach((item) => {
          newErrorCache[`${item.id}`] = {
            transcoding: item.transcodingStatus || "NOT_DONE",
            decoding: item.decodingStatus || "NOT_DONE",
            copy: item.copyStreamStatus || "NOT_DONE",
            ...(selectedType === "PROGRAM" ? { logoTranscoding: item.logoTranscodingStatus || "NOT_DONE" } : {}),
          };
        });
        setErrorCache(newErrorCache);
      } else {
        console.log(`fetchData failed for ${selectedType}:`, response);
        toast.error(`Fetching Asset information failed`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      }
      setSearchButtonClicked(false);
    } catch (error) {
      console.error("fetchData error:", error, "with params:", params);
      toast.error("Fetching Asset information failed", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
    finally{
      setIsContentLoading(false); // Stop loader after all content is set
    }
  }, [searchButtonClicked, selectedType, currentSortOrder]);

  async function fetchJobProgress() {
    try {
      const params = {
        partnerId: AssetPartnerDetail?.id || 1,
        pageSize: itemsPerPage,
        pageNumber: currentPage - 1,
        sortBy: currentSortOrder.sortBy,
        sortOrder: currentSortOrder.sortOrder,
        ...(searchQuerys ? { searchQuery: searchQuerys } : null),
      };
      let response;
      if (selectedType === "PROGRAM") {
        response = await ProgramsList_By_Partner(params);
      } else if (selectedType === "FILLER") {
        response = await FillerList(params);
      } else if (selectedType === "PROMO") {
        response = await PromosList_By_Partner(params);
      }

      if (response.status === true && response.data?.content) {
        setActionDetail(response.data.content);
        setActionData(response.data);
        setTotalPages(response.data?.totalPages || 0);
        if (response.data?.number + 1 > response.data?.totalPages) {
          setCurrentPage(response.data?.totalPages || 1);
          setInputPage(response.data?.totalPages || 1);
        }
        const newErrorCache = { ...errorCache };
        response.data.content.forEach((item) => {
          const assetErrorKey = `${item.id}`;
          if (!newErrorCache[assetErrorKey]) {
            newErrorCache[assetErrorKey] = {
              transcoding: item.transcodingStatus || "NOT_DONE",
              decoding: item.decodingStatus || "NOT_DONE",
              copy: item.copyStreamStatus || "NOT_DONE",
              ...(selectedType === "PROGRAM" ? { logoTranscoding: item.logoTranscodingStatus || "NOT_DONE" } : {}),
            };
          }
          newErrorCache[assetErrorKey].transcoding = item.transcodingStatus || "NOT_DONE";
          newErrorCache[assetErrorKey].decoding = item.decodingStatus || "NOT_DONE";
          newErrorCache[assetErrorKey].copy = item.copyStreamStatus || "NOT_DONE";
          if (selectedType === "PROGRAM") {
            newErrorCache[assetErrorKey].logoTranscoding = item.logoTranscodingStatus || "NOT_DONE";
          }
        });
        setErrorCache(newErrorCache);
      } else {
        toast.error("Fetching Job progress failed", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error("Fetching Job progress failed", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  }
  const checkInProgress = (data) => {
    const inProgress = data.some((item) => {
      const isProcessing =
        item.transcodingStatus === "SUBMITTED" ||
        item.transcodingStatus === "IN_PROGRESS" ||
        item.decodingStatus === "SUBMITTED" ||
        item.decodingStatus === "IN_PROGRESS" ||
        item.copyStreamStatus === "SUBMITTED" ||
        item.copyStreamStatus === "IN_PROGRESS" ||
        (item.transcodingStatus === "COMPLETED" &&
          (item.decodingStatus === null ||
            item.decodingStatus === "SUBMITTED" ||
            item.decodingStatus === "IN_PROGRESS" ||
            item.copyStreamStatus === null ||
            item.copyStreamStatus === "SUBMITTED" ||
            item.copyStreamStatus === "IN_PROGRESS")) ||
        item.transcodingStatus === "ERROR" ||
        item.decodingStatus === "ERROR" ||
        item.copyStreamStatus === "ERROR";

      console.log(
        `Asset ID ${item.id} (${selectedType}): transcoding=${item.transcodingStatus}, decoding=${item.decodingStatus}, copy=${item.copyStreamStatus}, inProgress=${isProcessing}`
      );
      return isProcessing;
    });
    console.log(`checkInProgress result for ${selectedType}:`, inProgress);
    return inProgress;
  };

  useEffect(() => {
    if (checkInProgress(actionDetail)) {
      intervalRef.current = setInterval(() => {
        fetchJobProgress()
          .then(() => console.log("fetchJobProgress completed successfully for", selectedType))
          .catch((error) => console.error("fetchJobProgress failed:", error));
      }, 10000);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [actionDetail, selectedType]);

  const checkTranscodingInProgress = (data) => {
    const inProgress = data.some(
      item => item.transcodingStatus === "SUBMITTED" || item.transcodingStatus === "IN_PROGRESS"
    );
    return inProgress;
  };

 const getPermission = useCallback(() => {
    const hasEditPermission = permissionDetails().includes("ASSET_MANAGEMENT_EDIT");
    setPermission(hasEditPermission);
  }, []);

 const resetState = useCallback(() =>  {
    setCheckedIds([]);
    disabledIds.length = 0
    setChecked(false);
    setDisabledFiled(false);
    setPublishActive(false);
    fetchData(currentPage);
 }, [currentPage,fetchData]);

  useEffect(() => {
    getPermission();
    resetState()
  }, [resetState, getPermission]);

  const blankValue = (
    <>
      <img src={pending} alt="Pending" style={{ marginRight: "6px", width: 20, height: 20 }} /> Pending
    </>
  );

  const submittedValue = (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "auto",
        // borderRadius: "18px",
      }}
    >
      <div
        style={{
          backgroundColor: "#162E6A",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "6px",
          marginLeft: "0px",
        }}
      >
        <img
          src={processing}
          alt="Preparing"
          className="animated-icon"
          style={{
            width: "12px",
            height: "12px",
            // padding: "4px",
          }}
        />
      </div>
      <span style={{ cursor: "pointer", color: "#000", display: "flex", alignItems: "center" }}>
        Preparing
      </span>
    </div>
  );

  const overriddenValue = (
    <>
      <img src={override} style={{ marginRight: "2px", width: 20, height: 20 }} alt="Overridden"/> Overridden
    </>
  );

  const actionStatus = (status) => {
    if (status === "NOT_DONE" || status == null) return "pending";
    if (status === "ERROR") return "error";
    if (status === "SUBMITTED") return "preparing";
    if (status === "IN_PROGRESS") return "in-progress";
    if (status === "Finalising") return "finalising";
    if (status === "COMPLETED" || status === "Done") return "complete";
    if (status === "OVERRIDDEN") return "OverRiden";
    return "pending";
  };
  const errorstatus = (status, jobPercentComplete, index, data, statusType) => {
    const transcodingStatus = data?.transcodingStatus;
    const decodingStatus = data?.decodingStatus;
    const copyStreamStatus = data?.copyStreamStatus;
    const logoTranscodingStatus = selectedType === "PROGRAM" ? data?.logoTranscodingStatus : null;
    const completeTranscodingStatus = selectedType === "PROGRAM" ? data?.completeTranscodingStatus : null;
    const completeJobPercentage = selectedType === "PROGRAM" ? data?.completeJobPercentage : null;
    const applyLogo =  selectedType === "PROGRAM" ? data?.applyLogo : null
    const updatedAt = data?.updatedAt;
    const transcodedDate = data?.dateTranscoded

    const determineStatus = () => {
      if (selectedType === "PROGRAM") {
  if (
    copyStreamStatus === "ERROR" ||
    decodingStatus === "ERROR" ||
    completeTranscodingStatus === "ERROR" ||
    logoTranscodingStatus === "ERROR" || transcodingStatus === 'ERROR'
  ) {
    return "error";
  }
if(applyLogo){ 
  if(
    (transcodingStatus === "COMPLETED" && logoTranscodingStatus=== "COMPLETED") &&
    (decodingStatus === null || copyStreamStatus === null)
  ){

    return "finalising"
  }
}

  if (
    completeTranscodingStatus === null &&
    decodingStatus === null &&
    copyStreamStatus === null &&
    logoTranscodingStatus === null
  ) {
    return "pending";
  }
  if (completeTranscodingStatus === "IN_PROGRESS") {
    const percent = completeJobPercentage || 0;
    return `inprogress ${percent}%`;
  }
  if (completeTranscodingStatus !== "COMPLETED") {
    return "preparing";
  }
 if (
    completeTranscodingStatus === "COMPLETED" &&
    (decodingStatus === null || copyStreamStatus === null)
  ) {
    return "finalising";
  }

  if (
    completeTranscodingStatus === "COMPLETED" &&
    decodingStatus === "COMPLETED" &&
    copyStreamStatus === "COMPLETED"
  ) {
    if (transcodedDate) {
      const date = new Date(transcodedDate);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
    return "completed";
  }
  if (
    completeTranscodingStatus === "COMPLETED" &&
    decodingStatus === null &&
    copyStreamStatus === null
  ) {
    return "finalising";
  }
  if (
    completeTranscodingStatus === "COMPLETED" &&
    decodingStatus === "COMPLETED" &&
    copyStreamStatus === null
  ) {
    return "finalising";
  }
  switch (completeTranscodingStatus) {
    case "COMPLETED":
      return "completed";
    case "IN_PROGRESS":
      return `inprogress ${completeJobPercentage || 0}%`;
    case "SUBMITTED":
      return "preparing";
    case "ERROR":
      return "error";
    default:
      return "pending";
  }
}
      if (
              transcodingStatus === "ERROR" ||
              decodingStatus === "ERROR" ||
              copyStreamStatus === "ERROR"
            ) {
              return "error";
            }
 
      if (
        transcodingStatus === "COMPLETED" &&
        (decodingStatus === null || copyStreamStatus === null)
      ) {
        return "finalising";
      }

      if (
        transcodingStatus === "COMPLETED" &&
        decodingStatus === "COMPLETED" &&
        copyStreamStatus === "COMPLETED"
      ) {
        if (updatedAt) {
          const date = new Date(updatedAt);
          return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        }
        return "completed";
      }

      if (
        transcodingStatus === "COMPLETED" &&
        decodingStatus === null &&
        copyStreamStatus === null
      ) {
        return "finalising";
      }

      if (
        transcodingStatus === "COMPLETED" &&
        decodingStatus === "COMPLETED" &&
        copyStreamStatus === null
      ) {
        return "finalising";
      }

      if (
        transcodingStatus === "SUBMITTED" &&
        decodingStatus === null &&
        copyStreamStatus === null
      ) {
        return "preparing";
      }

      if (
        transcodingStatus === "IN_PROGRESS" &&
        decodingStatus === null &&
        copyStreamStatus === null
      ) {
        if( jobPercentComplete === undefined ){
            jobPercentComplete = data.jobPercentComplete
        }
        return `inprogress ${jobPercentComplete || 0}%`;
      }

      if (
        transcodingStatus === null &&
        decodingStatus === null &&
        copyStreamStatus === null
      ) {
        return "pending";
      }

     

      if (
        transcodingStatus === decodingStatus &&
        decodingStatus === copyStreamStatus
      ) {
        switch (transcodingStatus) {
          case "PENDING":
            return "pending";
          case "PREPARING":
            return "preparing";
          default:
            return "inprogress";
        }
      }

      return "inprogress";
    };


    const determinedStatus = determineStatus();

    if (determinedStatus === "finalising" && statusType === "transcode") {
      return (
        <div className="status-finalising">
          <img
            src={FinalisingIcon}
            alt="Finalising"
            className="spin-icon"
            style={{ marginRight: "6px", width: 20, height: 20 }}
          />
          Finalising
        </div>
      );
    }

    if (determinedStatus === "error" && statusType === "transcode") {
      const errorSource =
        selectedType === "PROGRAM" && (completeTranscodingStatus === "ERROR" || logoTranscodingStatus === "ERROR")
          ? "Transcode Error"
          : transcodingStatus === "ERROR"
            ? "Transcode Error"
            : decodingStatus === "ERROR"
              ? "Decode Error"
              : copyStreamStatus === "ERROR"
                ? "Copy Error"
                : "Error";
      const errorMessage = data?.message || "An error occurred during processing";

      return (
        <span
          className="error-status"
          onClick={() =>
            setErrorPopup({
              isOpen: true,
              message: errorMessage,
              assetData: data,
              errorType: errorSource.toLowerCase().replace(" ", ""),
            })
          }
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          title={errorSource}
        >
          <img
            src={error}
            alt={errorSource}
            style={{ marginRight: "6px", width: 20, height: 20 }}
          />
          {errorSource}
        </span>
      );
    }

    if (determinedStatus === "preparing" && statusType === "transcode") {
      return submittedValue;
    }

    if (determinedStatus.startsWith("inprogress") && statusType === "transcode") {
      const percentComplete = selectedType === "PROGRAM"
        ? completeJobPercentage || 0
        : parseInt(determinedStatus.split(" ")[1]) || 0;
      return (
        <div
          className="in-progress"
          onMouseEnter={() =>
            setTooltipVisible((prev) => ({
              ...prev,
              [`${statusType}-${index}`]: true,
            }))
          }
          onMouseLeave={() =>
            setTooltipVisible((prev) => ({
              ...prev,
              [`${statusType}-${index}`]: false,
            }))
          }
        >
          <div className="progress-slider" style={{ width: `${percentComplete}%` }} />
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              background: "#4B3913",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "6px",
              // marginLeft: "3px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <span
              style={{
                fontSize: "8px",
                color: "#FABD40",
                fontWeight: 500,
                zIndex: 2,
              }}
            >
              {percentComplete != null ? `${percentComplete}%` : "0%"}
            </span>
          </div>
          <span style={{ zIndex: 2 }}>In Progress</span>
        </div>
      );
    }

    if (determinedStatus === "pending" && statusType === "transcode") {
      return blankValue;
    }

    if (determinedStatus === "finalise" && statusType === "transcode") {
      return (
        <div className="finalising">
          <img
            src={FinalisingIcon}
            alt="Finalise"
            style={{ marginRight: "6px", width: 20, height: 20 }}
          />
          Finalise
        </div>
      );
    }

    if (determinedStatus.includes("/") && statusType === "transcode") {
      return (
        <>
          <img src={donecheck} style={{ marginRight: "6px", width: 20, height: 20 }}  alt="donecheck"/>
          {determinedStatus}
        </>
      );
    }

    if (determinedStatus === "completed" && statusType === "transcode") {
      return (
        <>
          <img src={donecheck} style={{ marginRight: "6px", width: 20, height: 20 }} alt="donecheck" />
          Completed
        </>
      );
    }
    const effectiveStatus =
      statusType === "transcode"
        ? selectedType === "PROGRAM"
          ? completeTranscodingStatus || "NOT_DONE"
          : transcodingStatus || status || "NOT_DONE"
        : statusType === "decode"
          ? decodingStatus || status || "NOT_DONE"
          : statusType === "copy"
            ? copyStreamStatus || status || "NOT_DONE"
            : status || "NOT_DONE";

    if (effectiveStatus === "NOT_DONE" || effectiveStatus == null) return blankValue;
    if (effectiveStatus === "OVERRIDDEN") return overriddenValue;
    if (effectiveStatus === "SUBMITTED") return submittedValue;

    return (
      <>
        <img
          src={processing}
          alt={effectiveStatus}
          style={{ marginRight: "6px", width: 20, height: 20 }}
        />
        {effectiveStatus}
      </>
    );
  };

  const validationation = async (data) => {
    if (data?.validationStatus != null && data?.validationStatus !== "COMPLETED") {
      const actionData = { assetIds: [data.id] };
      try {
        const validate = await AssetValidate(actionData);
        console.log("AssetValidate response:", validate);
        if (validate?.data?.status === true) {
          setValidate(validate?.data?.data[0]);
          setAssetSignledata(data);
          setValidatePopup(true);
        } else {
          toast.error("Asset validation failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      } catch (error) {
        console.error("Validation error:", error);
        toast.error(`Asset validation failed: ${error.message}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      }
    }
  };
  const handleOverrideSuccess = () => {
    console.log("Override success, refreshing data...");
    fetchData(currentPage);
    setValidatePopup(false);
    setValidate(null);
    setAssetSignledata(null);
  };
  const handleReTranscode = async (assetData) => {
    try {
      setIsProcessing(true);
      setCurrentAction("Processing Re-Transcoding... Please wait.");
      if (!assetData?.id || isNaN(Number(assetData.id))) {
        throw new Error("Invalid asset ID");
      }
      console.log("Initiating re-transcode for assetId:", assetData.id);
      const videoType = selectedType.toUpperCase();
      const response = await Asset_retranscode([Number(assetData.id)], videoType);
      console.log("Re-transcode response:", JSON.stringify(response, null, 2));

      if (response?.status === true || response?.data?.status === true) {
        toast.success("Transcode process re-initiated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
        fetchData(currentPage);
        setErrorCache((prev) => ({
          ...prev,
          [`${assetData.id}`]: { ...prev[`${assetData.id}`], transcoding: "SUBMITTED" },
        }));
      } else {
        console.warn("Re-transcode failed with response:", JSON.stringify(response, null, 2));
        toast.error(`Transcode operation failed: ${response?.data?.error || response?.error || ""}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("handleReTranscode error:", error, "for assetData:", assetData);
      toast.error(`Transcode operation failed: ${error.message || ""}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } finally {
      setIsProcessing(false);
      setCurrentAction("");
      setErrorPopup({ isOpen: false, message: "", assetData: null, errorType: null });
      setCheckedIds([]);
      setTranscodeActive(false);
      setDisabledFiled(false);
    }
  };

  const handleReDecode = async (assetData, useAWS = false) => {
    try {
      setIsProcessing(true);
      setCurrentAction("Processing Re-Decoding... Please wait.");

      console.log("Initiating re-decode for assetId:", assetData.id);

      const actionData = {
        assetIds: [Number(assetData.id)],
        videoType: selectedType,
        assemblyType: useAWS ? "AWS" : "RUNN_MEDIA",
      };

      console.log("Re-decode payload:", JSON.stringify(actionData, null, 2));

      const response = await DecodeAssetStatus(actionData);
      console.log("Re-decode response:", JSON.stringify(response, null, 2));

      if (response?.status === true || response?.data?.status === true || response?.status === 200) {
        toast.success("Decode process re-initiated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
        fetchData(currentPage);
        setErrorCache((prev) => ({
          ...prev,
          [`${assetData.id}`]: { ...prev[`${assetData.id}`], decoding: "SUBMITTED" },
        }));
      } else {
        console.warn("Re-decode failed with response:", JSON.stringify(response, null, 2));
        toast.error(`Re-decode operation failed: ${response?.data?.message || response?.message || ""}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("handleReDecode error:", error, "for assetData:", assetData);
      toast.error(`Re-decode operation failed: ${error.response?.data?.message || error.message || ""}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } finally {
      setIsProcessing(false);
      setCurrentAction("");
      setErrorPopup({ isOpen: false, message: '', assetData: null, errorType: null });
      setCheckedIds([]);
      setDisabledFiled(false);
    }
  };

  const handleReCopy = async (assetData) => {
    try {
      setIsProcessing(true);
      setCurrentAction("Processing Re-Copying... Please wait.");

      const partnerId = AssetPartnerDetail?.id || 2;
      const videoType = selectedType.toUpperCase();

      console.log("Re-copy parameters:", {
        partnerId,
        assetId: assetData.id,
        videoType,
      });

      const response = await CopyAsset(partnerId, assetData.id, videoType);
      console.log("Re-copy response:", JSON.stringify(response, null, 2));

      if (response?.status === true || response?.data?.status === true || response?.status === 200) {
        toast.success("Copy process re-initiated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
        setErrorCache((prev) => ({
          ...prev,
          [`${assetData.id}`]: { ...prev[`${assetData.id}`], copy: "SUBMITTED" },
        }));
        await fetchJobProgress();
      } else {
        console.warn("Re-copy failed with response:", JSON.stringify(response, null, 2));
        toast.error(`Copy operation failed: ${response?.data?.message || response?.message || ""}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("handleReCopy error:", error, "for assetData:", assetData);
      toast.error(`Copy operation failed: ${error.response?.data?.message || error.message || ""}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } finally {
      setIsProcessing(false);
      setCurrentAction("");
      setErrorPopup({ isOpen: false, message: "", assetData: null, errorType: null });
      setCheckedIds([]);
      setDisabledFiled(false);
    }
  };

  const AssetActions = async (actionType, state) => {
    let assemblyType = "";
    let loaderMessage = "";

    if (actionType === "TRANSCODE") {
      assemblyType = state ? "AWS" : "RUNN_MEDIA";
      loaderMessage = state ? "Processing Transcoding to AWS... Please wait." : "Submitted";
    } else if (actionType === "VALIDATE") {
      assemblyType = "EXTERNAL";
      loaderMessage = "Processing Validation... Please wait.";
    } else if (actionType === "RUNN_MEDIA" || actionType === "AWS") {
      assemblyType = actionType === "RUNN_MEDIA" ? "RUNN_MEDIA" : "AWS";
      loaderMessage = actionType === "RUNN_MEDIA"
        ? "Publishing content to Runn Playout... Please wait."
        : "Publishing content to AWS Mediatailor... Please wait.";
    } else if (actionType === "RUNN_MEDIA_LOGO") {
      loaderMessage = "Publishing content with logo to Runn Playout... Please wait.";
      assemblyType = "RUNN_MEDIA_LOGO";
    }

    const actionData = actionType === "RUNN_MEDIA_LOGO"
      ? { assetIds: checkedIds }
      : {
        actionType: actionType,
        assetIds: checkedIds,
        videoType: selectedType,
        transcodingProvider: state ? "AWS_MEDIA_CONVERT" : "R_MEDIA_ENCODER",
        assemblyType: assemblyType,
      };

    try {
      setIsProcessing(true);
      setCurrentAction(loaderMessage);

      console.log(`Initiating ${actionType} with data:`, actionData);

      if (actionType === "RUNN_MEDIA_LOGO") {
        const logoPublish = await AssetLogoAction(actionData);
        console.log("AssetLogoAction response:", logoPublish);
        if (logoPublish?.data?.status === true) {
          toast.success("Content published successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
          resetState();
        } else {
          console.log("AssetLogoAction failed:", logoPublish);
          toast.error("Content publish operation failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      } else if (actionType === "TRANSCODE") {
        const transcode = await AssetTranscode(actionData);
        console.log("AssetTranscode response:", transcode);
        if (transcode?.data?.status === true) {
          toast.success("Transcode process initiated successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
          resetState();
          fetchJobProgress();
        } else {
          console.log("AssetTranscode failed:", transcode);
          handleError();
        }
      } else if (actionType === "VALIDATE") {
        const validate = await AssetValidate(actionData);
        console.log("AssetValidate response:", validate);
        if (validate?.data?.status === true) {
          setValidate(validate?.data?.data[0]);
          toast.success("Content validated successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
          resetState();
        } else {
          console.log("AssetValidate failed:", validate);
          handleError();
        }
      } else if (actionType === "RUNN_MEDIA" || actionType === "AWS") {
        const publish = await AssetPublish(actionData);
        console.log("AssetPublish response:", publish);
        if (publish?.data?.status === true) {
          toast.success("Content published successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
          resetState();
        } else {
          console.log("AssetPublish failed:", publish);
          handleError();
        }
      }
    } catch (error) {
      console.error(`AssetActions error for ${actionType}:`, error, "with data:", actionData);
      toast.error(`An error occurred during ${actionType.toLowerCase()}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } finally {
      setIsProcessing(false);
      setCurrentAction("");
    }
  };

 

  const handleError = () => {
    console.log("handleError triggered");
    toast.error("Something went wrong, please try again later", {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
    });
  };

  useEffect(() => {
    if (actionData && actionData.totalElements) {
      setTotalPages(Math.ceil(actionData.totalElements / itemsPerPage));
    }
  }, [actionData, itemsPerPage]);

  const handleInputChange = (event) => {
    setInputPage(event.target.value);
  };

  const handlePageKeyPress = (event) => {
    if (event.key === "Enter") {
      const newPage = Math.max(1, Math.min(totalPages, Number(inputPage)));
      setCurrentPage(newPage);
      setInputPage(newPage);
      // fetchData(newPage);
    }
  };

  const handlePageChange = (direction) => {
     setIsContentLoading(true); // Start loader
    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      setInputPage(newPage);
      // fetchData(newPage)
    }
     setIsContentLoading(false); // Stop loader after all content is set

  };

  const [sortOrders, setSortOrders] = useState({});
  useEffect(() => {
    isLogin();
    const initialSortOrders = {
      filename: "asc",
      duration: "",
      dateUploaded: "",
      dateValidated: "",
      datePublished: "",
      dateTranscoded: "",
    };
    setSortOrders(initialSortOrders);
  }, [selectedType]);

  const handleSort = async (field) => {
    let currentSortOrder = sortOrders[field] === "asc" ? "desc" : "asc";
    const params = {
      partnerId: AssetPartnerDetail?.id,
      sortBy: field,
      sortOrder: currentSortOrder,
      pageNumber: currentPage - 1,
      pageSize: itemsPerPage,
    };
    setCurrentSortOrder({
      sortBy: field,
      sortOrder: currentSortOrder,
    });

    try {
      let updatedData;
      if (selectedType === "PROGRAM") {
        updatedData = await ProgramsList_By_Partner(params);
      } else if (selectedType === "FILLER") {
        updatedData = await FillerList(params);
      } else if (selectedType === "PROMO") {
        updatedData = await PromosList_By_Partner(params);
      }

      if (updatedData.status === true) {
        const newData = updatedData.data;
        const newDataContent = newData?.content || [];
        localStorage.setItem(
          selectedType === "PROGRAM"
            ? "AssetDetail"
            : selectedType === "FILLER"
              ? "fillerDetail"
              : "PromoDetail",
          JSON.stringify(newData)
        );
        setActionDetail(newDataContent);
        setSortOrders(prev => ({
          ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
          [field]: currentSortOrder,
        }));
      } else {
        console.log("handleSort failed for field:", field, "with response:", updatedData);
      }
    } catch (error) {
      console.error("handleSort error:", error, "for field:", field);
    }
  };

  const getSortIcon = (field) => {
    if (!sortOrders[field]) return <img src={filterimg} alt="filterimg" />;
    return sortOrders[field] === "desc" ? (
      <img src={desc} alt="desc" />
    ) : (
      <img src={filter_alt} alt="Ascending" />
    );
  };

  const handleSearch = (event) => {
    setSearchQuery(event)
    if (event.length >= 3 || event.length < 1) {
      setSearchButtonClicked(true);
    }
  };

 const handleCheckboxChange = (e, data, index) => {
    const checked = e.target.checked;
    let updatedCheckedIds = [...checkedIds];

    if (checked) {
      //Final State
      if(data?.published === true ||
            data?.published === "COMPLETED"){
          setTranscodeActive(false);
          setValidateActive(false);
          setPublishActive(false);
          setDisabledFiled({
            transcodingStatus: data?.transcodingStatus,
            validationStatus: data?.validationStatus,
            published: data?.published,
          });
            }

      //pending state or error state in transcode      
      else if((data?.transcodingStatus === null || data?.completeTranscodingStatus === null)) {
        setTranscodeActive(true);
        setValidateActive(false);
        setPublishActive(false);
        setDisabledFiled(data?.transcodingStatus);
      }

      else if((data?.transcodingStatus === "COMPLETED" || data?.transcodingStatus === "ERROR") && (data.decodingStatus === "ERROR" || data.copyStreamStatus === "ERROR" || (selectedType === "PROGRAM" &&
           (data?.completeTranscodingStatus === "ERROR" || (data.applyLogo && data?.logoTranscodingStatus === "ERROR") ) ))){
        setTranscodeActive(true);
        setValidateActive(false);
        setPublishActive(false);
        setDisabledFiled("ERROR");
      }
      else if(data?.transcodingStatus === "COMPLETED" && data?.decodingStatus === "COMPLETED" && data?.copyStreamStatus === "COMPLETED") {

       // Transcode Completed and Validation is in pending state or Error State
        if ((data?.validationStatus == null || data.validationStatus === "ERROR") ) {
          setTranscodeActive(false);
          setValidateActive(true);
          setPublishActive(false);
          setDisabledFiled({
            transcodingStatus: data?.transcodingStatus,
            validationStatus: data?.validationStatus,
          });
        }
        // Validate is in OverRidden state
         else if(data?.validationStatus === "OVERRIDDEN") {
          setTranscodeActive(false);
          setValidateActive(true);
          setPublishActive(true);
          setDisabledFiled({
            transcodingStatus: data?.transcodingStatus,
            validationStatus: data?.validationStatus,
            published: data?.published,
          });
        } 
        else if(data?.validationStatus === "COMPLETED" && (data?.published === false || data?.published == null)) {
            setTranscodeActive(false);
            setValidateActive(false);
            setPublishActive(true);
            setDisabledFiled({
              transcodingStatus: data?.transcodingStatus,
              validationStatus: data?.validationStatus,
              published: data?.published,
            });
          
        }
        else {
          setTranscodeActive(false);
          setValidateActive(false);
          setPublishActive(false);
          setDisabledFiled({
            transcodingStatus: data?.transcodingStatus,
            validationStatus: data?.validationStatus,
            published: data?.published,
          });
        }
      }

      updatedCheckedIds.push(data.id);
    } else {
      updatedCheckedIds = updatedCheckedIds.filter((id) => id !== data.id);
    }

    setCheckedIds(updatedCheckedIds);
    if (updatedCheckedIds.length === 0) {
      setChecked(false);
      setDisabledFiled(false);
      setPublishActive(false);
      setValidateActive(false);
      setTranscodeActive(false);
    } else {
      // setChecked(true);
      // setAllcheck(updatedCheckedIds.length !== actionDetail.length);
    }
  };
  const navigate = useNavigate();
  const navigateBack = () => {
    navigate(-1);
  };

  const handleSelectAllClick = () => {
    let updatedCheckedIds = [...checkedIds];
      if(!isChecked)
      {actionDetail.forEach((data, index) => {
       if(!disabledIds.includes(data.id)){
            setChecked(true)
            updatedCheckedIds.push(data.id);
        }
      });
    }
    else {
        updatedCheckedIds = [];
        disabledIds.length = 0
        setChecked(false);
        setDisabledFiled(false);
        setPublishActive(false);
    }
    setCheckedIds(updatedCheckedIds);
    setAllcheck(false);
  };

  const rotations = async () => {
    if (!disabled) {
      setDisabled(true);
      setRotation((prev) => prev + 360);
      try {
        const params = {
          partnerId: AssetPartnerDetail?.id || 1,
          pageSize: itemsPerPage,
          pageNumber: currentPage - 1,
          sortBy: currentSortOrder.sortBy,
          sortOrder: currentSortOrder.sortOrder,
          ...(searchQuerys ? { searchQuery: searchQuerys } : null),
        };
        let response;
        if (selectedType === "PROGRAM") {
          response = await ProgramsList_By_Partner(params);
        } else if (selectedType === "FILLER") {
          response = await FillerList(params);
        } else if (selectedType === "PROMO") {
          response = await PromosList_By_Partner(params);
        } else {
          response = await ProgramsList_By_Partner(params);
        }
        if (response.status === true && response.data?.content) {
          setActionDetail(response.data.content);
          setActionData(response.data);
          setTotalPages(response.data?.totalPages || 0);
          if (response.data?.number + 1 > response.data?.totalPages) {
            setCurrentPage(response.data?.totalPages || 1);
            setInputPage(response.data?.totalPages || 1);
          }
          const newErrorCache = { ...errorCache };
          response.data.content.forEach((item) => {
            const assetErrorKey = `${item.id}`;
            newErrorCache[assetErrorKey] = {
              transcoding: item.transcodingStatus || "NOT_DONE",
              decoding: item.decodingStatus || "NOT_DONE",
              copy: item.copyStreamStatus || "NOT_DONE",
              validation: item.validationStatus || "NOT_DONE",
            };
          });
          setErrorCache(newErrorCache);
          toast.success("Status updated successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 2000,
          });
        } else {
          toast.error("Status update operation failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      } catch (error) {
        console.error("Refresh failed", error);
        toast.error("Status update operation failed", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      } finally {
        setTimeout(() => {
          setDisabled(false);
        }, 5000);
      }
    }
  };

  const shouldDisableCheckbox = (data, disabledFiled) => {
    if (!data) return true;
    if(((data?.published !== false && disabledFiled?.published === false) ||
        (data?.published !== true && disabledFiled?.published === true) || (data?.published !== "COMPLETED" && disabledFiled?.published === "COMPLETED"))){
          disabledIds.push(data.id)
      return true
    }
    if(disabledFiled === null && (data?.transcodingStatus === "COMPLETED")){
       disabledIds.push(data.id)
      return true;

    }
    if(disabledFiled === "ERROR" && ((data?.transcodingStatus === "COMPLETED" && data?.completeTranscodingStatus !== "ERROR" && data?.completeTranscodingStatus !== null )))
    {
      if((data?.decodingStatus === "ERROR" || data?.decodingStatus == null)||
      (data?.copyStreamStatus === "ERROR" || data?.copyStreamStatus === null))
      {
        return false;
      }
      else {
        disabledIds.push(data.id)
        return true;
    }
    }
  
    if(disabledFiled?.transcodingStatus === "COMPLETED" && !isTreeCompleted(data) && data?.published !== "COMPLETED")
    {
      disabledIds.push(data.id)
      return true
    }
    if ((disabledFiled?.validationStatus === "COMPLETED" || disabledFiled?.validationStatus === "OVERRIDDEN") && (data?.validationStatus === null || data?.validationStatus === "ERROR"))
      {
        disabledIds.push(data.id)
        return true
      }

  };

  const isTreeCompleted = (data) => {
    const isFinalising =
      data?.transcodingStatus === "COMPLETED" &&
      (data?.decodingStatus === null || data?.copyStreamStatus === null);
    if (selectedType === "PROGRAM") {
      return (
        !isFinalising &&
        data?.transcodingStatus === "COMPLETED" &&
        data?.decodingStatus === "COMPLETED" &&
        data?.copyStreamStatus === "COMPLETED" &&
        data?.completeTranscodingStatus === "COMPLETED"
      );
    } else {
      return (
        !isFinalising &&
        data?.transcodingStatus === "COMPLETED" &&
        data?.decodingStatus === "COMPLETED" &&
        data?.copyStreamStatus === "COMPLETED"
      );
    }
  };

  return (
    <div className="content-body" style={{backgroundColor:"#1A1A1A"}}> 
      <div className="dashboard-content">
        <div className="top-content">
          <div className="left-side">
            <div className="breadcrumbs bread-action">
              <ul>
                <li><a href="/asset">Asset Management</a></li>
                <li><a onClick={navigateBack}>{AssetPartnerDetail?.name}</a></li>
                <li className="active">Actions</li>
              </ul>
            </div>
          </div>
          <div className="right-side">
            <SearchBar
              searchQuery={searchQuerys}
              placeholder="Search...."
              searchOutput={handleSearch}
              keyEnter={false}
              icon={Searchicon}
            />
          </div>
        </div>

        <div
          className="action-category"
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {permission && (
              <ul>
                <li className={transcodeActive && checkedIds.length > 0 ? "active" : "disable"}>
                  <div className="dropdown action-dropdown ">
                    <div
                      className="action-buttons"
                      onClick={() => (transcodeActive && checkedIds.length > 0 ? AssetActions("TRANSCODE", false) : null)}
                      
                    >
                      {/* {isProcessing && currentAction.includes("Transcoding") ? (
                        <span>{currentAction}</span>
                      ) : (
                        <>
                          Transcode
                          <span className="ml-2">▼</span>
                        </>
                      )} */}
                      Transcode
                    </div>
                    {/* {transcodeActive && checkedIds.length > 0 && (
                      <div className="dropdown-content w-auto">
                        <button
                          className="transoption"
                          onClick={() => transcodeActive && checkedIds.length > 0 ? AssetActions("TRANSCODE", false) : null}
                          style={{ fontSize: "14px", padding: "8px 14px" }}
                        >
                          Run Media Encoder
                        </button>
                        <button
                          className="transoption"
                          onClick={() => transcodeActive && checkedIds.length > 0 ? AssetActions("TRANSCODE", true) : null}
                          style={{ fontSize: "14px", padding: "8px 14px" }}
                        >
                          AWS MediaConvert
                        </button>
                      </div>
                    )} */}
                  </div>
                </li>
                <li className={validateActive && checkedIds.length > 0 ? "active" : "disable"}>
                  <div className="dropdown action-dropdown ">
                    <div
                      onClick={() => validateActive && checkedIds.length > 0 ? AssetActions("VALIDATE") : null}
                      className="action-buttons"
                    >
                      {/* {isProcessing && currentAction === "Processing Validation... Please wait." ? (
                        <span>{currentAction}</span>
                      ) : (
                        "Validate"
                      )} */}
                      Validate
                    </div>
                  </div>
                </li>
                <li className={publishActive && checkedIds.length > 0 ? "active" : "disable"} style={{ marginRight: 20 }}>
                  <div className="dropdown action-dropdown ">
                    <div className="action-buttons"
                    onClick={() => publishActive && checkedIds.length > 0 ? AssetActions("RUNN_MEDIA") : null} >
                      {/* {isProcessing && currentAction.includes("Publishing") ? (
                        <span>{currentAction}</span>
                      ) : (
                        <>
                          Publish
                          <span className="ml-2">▼</span>
                        </>
                      )} */}
                      Publish
                    </div>
                    {/* {publishActive && checkedIds.length > 0 && (
                      <div className="dropdown-content w-auto">
                        <button
                          className="transoption"
                          onClick={() => publishActive && checkedIds.length > 0 ? AssetActions("RUNN_MEDIA") : null}
                          style={{ fontSize: "14px", padding: "8px 14px" }}
                        >
                          Runn Playout
                        </button>
                        <button
                          className="transoption"
                          onClick={() => publishActive && checkedIds.length > 0 ? AssetActions("RUNN_MEDIA_LOGO") : null}
                          style={{ fontSize: "14px", padding: "8px 14px" }}
                        >
                          Runn Playout with Logo
                        </button>
                        <button
                          className="transoption"
                          onClick={() => publishActive && checkedIds.length > 0 ? AssetActions("AWS") : null}
                          style={{ fontSize: "14px", padding: "8px 14px" }}
                        >
                          AWS MediaTailor
                        </button>
                      </div>
                    )} */}
                  </div>
                </li>
              </ul>
            )}
            {/* {isProcessing && (
              <div className="loader-container">
                <div className="loader"></div>
                <p>{currentAction}</p>
              </div>
            )} */}
          </div>

          <div>
            <button
              className="refresh-button"
              onClick={rotations}
              disabled={disabled}
            >
              <img
                className={rotation !== 0 ? "rotate" : ""}
                style={{ transform: `rotate(${rotation}deg)` }}
                src={refresh}
                alt="refresh"
              />
            </button>
            {/* <button
              className="refresh-button m-2 border-1"
              // onClick={() => deleteAssets()}
              disabled={disabled}
            >
              <img
                className=""
                src={Delete}
                alt="Delete"
              />
            </button> */}
          </div>
        </div>

    { isContentLoading ? (
                <div style={{
                    height:"80vh",
                    width:"80vw",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                    borderRadius:"8px"
                  }}>
                  <Loader />
                </div>
                ): (  <div className="table-checkbox">
          <div className="actions-table" style={{ opacity: isContentLoading ? 0.5 : 1 }}>
            <table
              className="striped-table"
              style={{
                borderCollapse: "separate",
                borderSpacing: "0 6px",
                width: "100%",
              }}
            >
              <thead>
                <tr>
                  {permission && (
                    <th className="table-checkbox" style={{ fontSize: "14px", paddingRight: 30, width: "70px" }}>
                      <input
                        type="checkbox"
                        id="selectAllCheckbox"
                        checked={isChecked}
                        onChange={handleSelectAllClick}
                        disabled={checkedIds.length === 0}
                      />
                      <label className={isChecked ? "check" : null} htmlFor="selectAllCheckbox">
                      </label>
                    </th>
                  )}
                  <th style={{ textAlign: "left", fontSize: "14px", paddingLeft: 22, color: '#BFBFBF' }}>
                    {selectedType} Name
                    <span
                      className="filter-icon"
                      style={{ display: "inline-flex", alignItems: "center", marginLeft: "8px", cursor: "pointer" }}
                      onClick={() => handleSort("filename")}
                    >
                      {getSortIcon("filename")}
                    </span>
                  </th>
                  <th style={{ fontSize: "14px", color: "#BFBFBF", position: "relative" }}>
                    <div style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }} onClick={toggleDropdown}>
                      <span style={{ color: isDropdownOpen ? "#D22F26" : "#BFBFBF",fontSize: isDropdownOpen ? "14px" : "14px",  }}>Type</span>
                      <img
                        src={downarrow}
                        alt="Down Arrow"
                        style={{
                          marginLeft: "8px",
                          width: "10px",
                          height: "10px",
                          transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </div>
                    {isDropdownOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "80%",
                          right: "0px",
                          background: "#2E3033",
                          // border: "1px solid #ccc",
                          borderRadius: "6px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          zIndex: 1000,
                          width: "120px",
                        }}
                      >
                        {typeOptions.length === 0 ? (
                          <div style={{ padding: "8px 12px", textAlign: "center", fontSize: "14px", color: "#FFFFFF" }}>
                            No options available
                          </div>
                        ) : (
                          <div style={{ width: "100%", padding: "8px 0", fontSize: "14px", color: "#FFFFFF", background: "transparent" }}>
                            {typeOptions.map((option, index) => (
                              <div
                                key={index}
                                onClick={() => {
                                  setSelectedType(option);
                                  setIsDropdownOpen(false);
                                }}
                                style={{
                                  padding: "8px 12px",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s ease, color 0.3s ease",
                                  fontWeight:"400"
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "#FFFFFF1C";
                                  e.currentTarget.style.color = "#ffffff";
                                  e.currentTarget.style.borderRadius = "6px";
                                  e.currentTarget.style.margin="0px 8px";

                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "transparent";
                                  e.currentTarget.style.color = "#ffffff";
                                }}
                              >
                                {option}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </th>
                  <th style={{
                    fontSize: "14px", color: '#BFBFBF',
                    alignItems: 'center',
                  }}>
                    Duration
                    <span
                      className="filter-icon"
                      style={{ display: "inline-flex", marginLeft: "8px", cursor: "pointer" }}
                      onClick={() => handleSort("duration")}
                    >
                      {getSortIcon("duration")}
                    </span>
                    <br /><span style={{ fontWeight: 100, fontSize: 12, color: '#BFBFBF' }}> hh:mm:ss</span>
                  </th>
                  <th style={{ fontSize: "14px", color: '#BFBFBF' }}>
                    Date Uploaded
                    <span
                      className="filter-icon"
                      style={{ display: "inline-flex", alignItems: "center", marginLeft: "8px", cursor: "pointer" }}
                      onClick={() => handleSort("dateUploaded")}
                    >
                      {getSortIcon("dateUploaded")}
                    </span>
                    <br /><span style={{ fontWeight: 100, fontSize: 12, textAlign: "center", color: '#BFBFBF' }}> dd/mm/yy</span>
                  </th>
                  <th style={{ textAlign: "center", fontSize: "14px", color: '#BFBFBF' }}>
                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                      <span>Transcode</span>
                      <span
                        style={{ display: "inline-flex", alignItems: "right", marginLeft: "8px", cursor: "pointer" }}
                        onClick={() => handleSort("dateTranscoded")}
                      >
                        {getSortIcon("dateTranscoded")}
                      </span>
                    </div>
                  </th>
                  <th style={{ textAlign: "center", fontSize: "14px", color: '#BFBFBF' }}>
                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                      <span>Validate</span>
                      <span
                        style={{ display: "inline-flex", marginLeft: 7, cursor: "pointer" }}
                        onClick={() => handleSort("dateValidated")}
                      >
                        {getSortIcon("dateValidated")}
                      </span>
                    </div>
                  </th>
                  <th>
                    <div style={{ fontSize: 14, color: '#BFBFBF' }}>
                      <span>Publish</span>
                      <span onClick={() => handleSort("datePublished")} style={{ cursor: "pointer", marginLeft: 7 }}>
                        {getSortIcon("datePublished")}
                      </span>
                    </div>
                  </th>
                </tr>
              </thead>
               {actionDetail.length !== 0 ? (<tbody>
                {actionDetail.map((data, index) => (
                 
                  <tr key={index} className={`${index % 2 === 0 ? 'even' : 'odd'} hover:bg-gray-100`}>
                    {permission && (
                      <td style={{ textAlign: 'left' }}>
                        <input
                          id={data.id}
                          type="checkbox"
                          onChange={(e) => data?.active !== false ? handleCheckboxChange(e, data, index) : null}
                          checked={checkedIds.includes(data.id)}
                          disabled={shouldDisableCheckbox(data, disabledFiled)}
                        />
                        <label htmlFor={data.id}> </label>
                      </td>
                    )}
                    <td
                      style={{
                        paddingRight: '20px',
                        textAlign: 'left',
                        fontSize: 14,
                        maxWidth: '290px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        position: 'relative',
                        //  ,
                        cursor: 'pointer',
                      }}
                    >
                      <CustomTooltip text={data?.metadata?.title || data.filename || 'No title'}>
                        <span>{data?.metadata?.title || data.filename || 'No title'}</span>
                      </CustomTooltip>
                    </td>
                    <td style={{ textAlign: 'center', fontSize:14,   }}>
                      {data.videoType ? data.videoType : selectedType}
                    </td>
                    <td
                      style={{ textAlign: 'center', fontSize: 14,   }}
                      title={data.duration != null ? `Duration: ${convertTimestampToTime(data.duration)}` : 'Duration: N/A'}
                    >
                      {data.duration != null
                        ? convertTimestampToTime(data.duration)
                        : data.metadata?.duration || 'N/A'}
                    </td>
                    <td
                      style={{ textAlign: 'center', fontSize: 14,   }}
                      title={`Uploaded on: ${DateStamp(data.dateUploaded)}`}
                    >
                      {DateStamp(data.dateUploaded)}
                    </td>

                    <td style={{ position: 'relative', textAlign: 'right' }}>
                      <div
                        className={
                          data?.transcodingStatus === "ERROR" ||
                            data?.decodingStatus === "ERROR" ||
                            data?.copyStreamStatus === "ERROR" || data?.logoTranscodingStatus === "ERROR"
                            ? "error"
                            : isTreeCompleted(data)
                              ? "complete"
                              : data?.transcodingStatus === "COMPLETED" &&
                                (data?.decodingStatus === null || data?.copyStreamStatus === null)
                                ? "finalising"
                                : data?.transcodingStatus === null &&
                                  data?.decodingStatus === null &&
                                  data?.copyStreamStatus === null
                                  ? "pending"
                                  : data?.transcodingStatus === "SUBMITTED" &&
                                    data?.decodingStatus === null &&
                                    data?.copyStreamStatus === null
                                    ? "preparing"
                                    : data?.transcodingStatus === "IN_PROGRESS" &&
                                      data?.decodingStatus === null &&
                                      data?.copyStreamStatus === null
                                      ? "inprogress"
                                      : "unknown"
                        }
                      >
                        {errorstatus(data?.transcodingStatus, data?.completeJobPercentage, index, data, "transcode")}
                      </div>
                    </td>

                    <td style={{ textAlign: 'right', marginLeft: '120px',   }}>
                      <div
                        onClick={
                          data?.active !== false &&
                            data?.decodingStatus !== "ERROR" &&
                            data?.copyStreamStatus !== "ERROR"
                            ? () => validationation(data)
                            : null
                        }
                        className={actionStatus(data?.validationStatus)}
                        style={{
                          cursor:
                            data?.decodingStatus === "ERROR" || data?.copyStreamStatus === "ERROR"
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        {data?.validationStatus === "COMPLETED" ? (
                          <>
                            <img src={donecheck} style={{ marginRight: '6px', width: 20, height: 20 }} />
                            {DateStamp(data.dateValidated)}
                          </>
                        ) : data?.validationStatus === "ERROR" ? (
                          <span
                            className="error-status"
                            onClick={
                              data?.decodingStatus !== "ERROR" && data?.copyStreamStatus !== "ERROR"
                                ? () => validationation(data)
                                : null
                            }
                            style={{
                              cursor:
                                data?.decodingStatus === "ERROR" || data?.copyStreamStatus === "ERROR"
                                  ? "not-allowed"
                                  : "pointer",
                              display: 'flex',
                              alignItems: 'center',
                            }}
                            title="Validation Error"
                          >
                            <img
                              src={error}
                              alt="Validation Error"
                              style={{ marginRight: '6px', width: 20, height: 20 }}
                            />
                            Error Summary
                          </span>
                        ) : data?.validationStatus === "SUBMITTED" ? (
                          submittedValue
                        ) : data?.validationStatus === "IN_PROGRESS" ? (
                          <div
                            className="in-progress"
                            onMouseEnter={() =>
                              setTooltipVisible((prev) => ({
                                ...prev,
                                [`validate-${index}`]: true,
                              }))
                            }
                            onMouseLeave={() =>
                              setTooltipVisible((prev) => ({
                                ...prev,
                                [`validate-${index}`]: false,
                              }))
                            }
                          >
                            <div className="progress-slider" style={{ width: `${data?.validationPercentComplete || 0}%` }} />
                            <div
                              style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                background: '#4B3913',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '6px',
                                // marginLeft: '8px',
                                position: 'relative',
                                zIndex: 1,
                              }}
                            >
                              <span
                                style={{
                                  fontSize: '10px',
                                  color: '#FABD40',
                                  fontWeight: 500,
                                  zIndex: 2,
                                }}
                              >
                                {data?.validationPercentComplete != null ? `${data?.validationPercentComplete}%` : '0%'}
                              </span>
                            </div>
                            <span style={{ zIndex: 2 }}>In Progress</span>
                            <span
                              className="progress-tooltip"
                              style={{
                                display: tooltipVisible[`validate-${index}`] ? 'block' : 'none',
                              }}
                            >
                              In Progress {data?.validationPercentComplete != null ? `${data?.validationPercentComplete}%` : '0%'}
                            </span>
                          </div>
                        ) : data?.validationStatus === "OVERRIDDEN" ? (
                          overriddenValue
                        ) : (
                          blankValue
                        )}
                      </div>
                    </td>
                    <td style={{ textAlign: 'right',   }}>
                      <div className={data?.published === true ? 'complete' : 'pending'}>
                        {data.datePublished === null ? (
                          blankValue
                        ) : (
                          <>
                            <img src={donecheck} style={{ marginRight: '6px', width: 20, height: 20 }} />
                            {DateStamp(data.datePublished)}
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>) : (<tbody>
                <tr>
                  <td colSpan="8" style={{ textAlign: "center", padding: "10px" }}>
                    No Data Found.
                  </td>
                </tr>
              </tbody>)}
            </table>
          </div>
          {actionDetail.length !== 0 && (
            <div className="table-pagination">
              <div className="pagination-count">
                {/* <div className="count">Page: {currentPage} of {totalPages}</div> */}
                <div className="count">
                  Showing <span>
                  {`${Math.min((currentPage - 1) * itemsPerPage + 1, actionData.totalElements)}-${Math.min(
                    currentPage * itemsPerPage,
                    actionData.totalElements
                  )} of ${actionData.totalElements}`} </span> entries
                </div>
                <div className="pagination-arrow">
                  <button
                    className={`prev ${currentPage === 1 ? "disabled" : ""}`}
                    onClick={() => handlePageChange("prev")}
                    disabled={currentPage === 1 || isContentLoading}
                  >
                    <PrevButton/>
                  </button>
                  <div className="pagesCounts">
                    Page
                    <form onSubmit={(e) => e.preventDefault()}>
                      <input
                        type="number"
                        name="inputpage"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handlePageKeyPress}
                        min={1}
                        max={totalPages}
                        className="no-arrows"
                      />
                    </form>
                    <span>of {totalPages}</span>
                  </div>
                  <button
                    className={`next ${currentPage === totalPages ? "disabled" : ""}`}
                    onClick={() => handlePageChange("next")}
                    disabled={currentPage === totalPages || isContentLoading}
                  >
                    <NextButton/>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>)}

        <ToastContainer
          position="bottom"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {validatepopup && (
          <Validatepopup
            handleClosePopup={() => {
              setValidatePopup(false);
              setValidate(null);
              setAssetSignledata(null);
            }}
            validateinfo={validatedata}
            assetsingledata={assetSignledata}
            permission={permission}
            onOverrideSuccess={handleOverrideSuccess}
          />
        )}
        <ErrorPopup
          isOpen={errorPopup.isOpen}
          onClose={() => setErrorPopup({ isOpen: false, message: '', assetData: null, errorType: null })}
          errorMessage={errorPopup.message}
          onReTranscode={handleReTranscode}
          onReDecode={handleReDecode}
          onReCopy={handleReCopy}
          assetData={errorPopup.assetData}
          errorType={errorPopup.errorType}
          errorCache={errorCache}
        />
      </div>
    </div>
  );
}